import { Id, Identifiable, Resource } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  uuid: Id;
  fridayHours: number;
  mondayHours: number;
  saturdayHours: number;
  sundayHours: number;
  thursdayHours: number;
  tuesdayHours: number;
  wednesdayHours: number;
};

function getPersonalWeeklyCalendar(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/resources/${resource.uuid}/weeklyCalendar`,
        method: HttpMethods.GET,
      })
      .then((response) => ({
        uuid: response.uuid,
        friday: { capacity: response.fridayHours },
        monday: { capacity: response.mondayHours },
        saturday: { capacity: response.saturdayHours },
        sunday: { capacity: response.sundayHours },
        thursday: { capacity: response.thursdayHours },
        tuesday: { capacity: response.tuesdayHours },
        wednesday: { capacity: response.wednesdayHours },
      }));
}

export { getPersonalWeeklyCalendar };
